import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import BlitzEntryForm from './BlitzEntryForm';
import BlitzAPI from '../../../api/BlitzAPI';
import { handleFormErrors } from '../../form/utils';

class BlitzEntryEdit extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.parseEntryFromUrl = this.parseEntryFromUrl.bind(this);
    this.state = {
      entry: null,
      error: null,
      loadParseUrl: false,
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    BlitzAPI.getEntry(this.props.params.entryId).then(
      response => this.setState({ entry: response.data.data }),
    );
  }

  handleSubmit(values) {
    const data = Object.assign({}, values);
    delete data.source;
    delete data.author;
    if (typeof data.top_image !== 'string') {
      delete data.top_image;
    }
    if (typeof data.cover_image !== 'string') {
      delete data.cover_image;
    }

    return BlitzAPI.patchEntry(this.props.params.entryId, { entry: data }).catch(handleFormErrors);
  }
  parseEntryFromUrl(url) {
    if (url) {
      this.setState({ loadParseUrl: true });
      BlitzAPI.parseEntryFromUrl({ url }).then(
        (response) => {
          this.setState({ loadParseUrl: false });
          this.setState({ entry: Object.assign(response.data.data, { is_blitz: true }) });
        },
      ).catch(() => {
        this.setState({ loadParseUrl: false });
      });
    }
  }

  render() {
    const { entry } = this.state;

    if (!entry) {
      return <div><h1>Loading</h1></div>;
    }
    return (
      <div>
        <h1 className="create-header">Edit this Entry</h1>
        <BlitzEntryForm
          onSubmit={this.handleSubmit}
          parseEntryFromUrl={this.parseEntryFromUrl}
          loadParseUrl={this.state.loadParseUrl}
          initialValues={entry}
          url={this.props.url}
        />
      </div>
    );
  }
}

BlitzEntryEdit.propTypes = {
  params: PropTypes.object,
  url: PropTypes.string,
};

export default withRouter(BlitzEntryEdit);



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/BlitzEntryEdit.js